import React from "react";
import FolderContent from "../content/folderContent";
import Layout from "../layout/Layout";

const Vehicles = () => {
  return (
    <Layout>
      <FolderContent />
    </Layout>
  );
};

export default Vehicles;
